import React, { forwardRef, useEffect, useImperativeHandle, useState } from 'react';
import { useDispatch } from 'react-redux';

// Shared UI Library Components
import {
  CodeBlock,
} from '@ppmcore/seven-ppm-core-shared-components-react';

// Store entities
import { openNotification } from '../../../../../../store/app-notifications/app-notifications.thunks';

// Styles
import './widget-code-block.scss';

// Models
import { TWidgetType } from '../../../../../../types/widget.types';
import { IWidgetInfo } from '../../../../../../interfaces/widget-settings.interfaces';

export type TWidgetCodeBlockRef = {};

type TWidgetCodeBlockProps = {
  type: TWidgetType;
  widget_settings: IWidgetInfo;
};

export const WidgetCodeBlock = forwardRef<TWidgetCodeBlockRef, TWidgetCodeBlockProps>(
  ({ type, widget_settings }: TWidgetCodeBlockProps, ref
  ) => {

    const [codeValues, setCodeValues] = useState<{
      styles: string,
      scripts: string,
    }>({
      styles: '',
      scripts: ''
    });

    const dispatch = useDispatch<any>();

    const onCopySuccessHandler = (): void => {
      dispatch(openNotification({
        type: 'success',
        description: 'Successfully copied!'
      }));
    }

    const onCopyErrorHandler = (): void => {
      dispatch(openNotification({
        type: 'error',
        description: 'Copy failed! Try again'
      }));
    }

    useImperativeHandle(ref, () => ({}));

    useEffect(() => {
      setCodeValues({
        styles: `<link rel="stylesheet" href="${ process.env.REACT_APP_WIDGET_APP_URL }/styles.min.css">`,
        scripts: `${ type === 'embedded' ? '<div class="ppt-embedded-widget-root"></div>' : '' }<script src="${ process.env.REACT_APP_WIDGET_APP_URL }/ppt-widget.min.js"></script><script type="text/javascript">const widget = new PayPerTokWidget({companyHash: "${ widget_settings.widget_hash }",widgetType: "${ type }"${ type === 'popup' ? `,tooltipMessage: "${ widget_settings.widget_text_message }",tooltipClose: ${ widget_settings.widget_show_text },buttonColor: "${ widget_settings.theme_settings.elemental_header_color }"` : '' }${ type === 'embedded' ? `,rootClass: "ppt-embedded-widget-root"` : '' }});widget.initWidget();</script>`
      })
    }, [widget_settings]);

    return (
      <div className="widget-code-block">
        <div className="widget-code-block--header">
          <div className="header-title">
            Install the below code on your website to start using { type === 'popup' ? 'Popup' : 'Embedded' } Widget
            {/*<CustomTooltip title={ 'Widget Code' }>*/ }
            {/*  <CustomIcon name={ EIconName.Info } size={ 'size-md' }/>*/ }
            {/*</CustomTooltip>*/ }
          </div>
        </div>
        <div className="widget-code-block--body">
          <div className="body-item body-item-label">
            Copy and paste this code right before the closing <b>{ '</head>' }</b> tag of your website's HTML source
            code:
          </div>
          <div className="body-item">
            <CodeBlock code={ codeValues.styles } onCopyError={ onCopyErrorHandler }
                       onCopySuccess={ onCopySuccessHandler }/>
          </div>
          <div className="body-item body-item-label">
            { type === 'popup' && <>Copy and paste this code right before the closing <b>{ '</body>' }</b> tag of your website's HTML source code:</> }
            { type === 'embedded' && 'Copy and paste this code into your website\'s HTML source at the desired location to display the PayPerTok Widget:' }
          </div>
          <div className="body-item">
            <CodeBlock code={ codeValues.scripts } onCopyError={ onCopyErrorHandler }
                       onCopySuccess={ onCopySuccessHandler }/>
          </div>
        </div>
      </div>
    );
  })
